module.exports = __webpack_public_path__ + "static/media/fa-v4compatibility.38fec630.ttf";